export enum ComposedFilterEvent {
	Picker = "Picker",
	Slider = "Slider",
	Filter = "Filter",
	Actions = "Actions",
}
